import * as React from 'react'
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'

export interface BreadcrumbType {
  active?: boolean
  link?: string
  name: string
}

export interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbType[]
}

function BreadcrumbsComponent(props: BreadcrumbsProps) {
  const { breadcrumbs } = props

  return (
    <Breadcrumb className="ggbreadcrumbs">
      {breadcrumbs.map((breadcrumb, i) => (
        <BreadcrumbItem key={i} active={breadcrumb.active}>
          {(breadcrumb.link)
            ? (<Link to={breadcrumb.link}>{breadcrumb.name}</Link>)
            : (breadcrumb.name)
          }
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  )
}

export default BreadcrumbsComponent



// WEBPACK FOOTER //
// ./src/routes/Breadcrumbs.component.tsx